import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Icon } from "@core/assets";
import { StaffFrame } from "@areas/staff";
import { requireCapability } from "./-guards";

// Pathless layout for the staff area (President and Administrator): the guard runs once for every
// child, then the frame mounts once and survives navigation between pages. The old `/staff/*`
// tree keeps its own layout (`staff.tsx`) until each workflow replaces its screens.
export const Route = createFileRoute("/_staff-area")({
  beforeLoad: ({ context, location }) =>
    requireCapability(context.queryClient, "team.read", location.pathname),
  // Shown only if resolving the profile takes a moment (hard reload): one quiet loading screen,
  // never a half-built frame.
  pendingComponent: FrameLoading,
  component: StaffLayout,
});

function StaffLayout() {
  return (
    <StaffFrame>
      <Outlet />
    </StaffFrame>
  );
}

function FrameLoading() {
  const { t } = useTranslation("common");

  return (
    <div
      role="status"
      className="flex min-h-screen items-center justify-center gap-xs bg-surface-page text-sm-regular text-(--text-secondary)"
    >
      <Icon name="loading" size={20} className="animate-spin" />
      {t("loading")}
    </div>
  );
}
